<!-- HEADER START -->
<div class="row">
  <div id="header-hidden"></div>
  @if (userDetail) {
  <div id="header">
    <div class="row">
      <div class="col-xl-8 col-lg-5 col-md-6 col-sm-8 col-8" style="align-content: center;">
        <a routerLink="/" title="same">
          <img src="theme/images/logo.svg" class="logo logo-bounce" width="160" alt="KudosHub Technologies"
            fetchpriority="high" decoding="async" />
        </a>
        @if (headerNavMenu) {
        <nav class="kudoshub-nav">
          <menu class="align-items-center h-100 m-0 p-0 collapse" id="navbarNav" style="align-content: center;">
            <img src="theme/images/logo.svg" class="logo logo-bounce" width="160"
              alt="KudosHub Technologies">
            <ul class="d-flex menu-block non-collapse-menu">
              <li>
                <a [href]="url+'#features'" title="features">Features</a>
              </li>
              <li>
                <a [href]="url+'#methods'" title="methods">Methods</a>
              </li>
              @if(url==='/email-validation'){
              <li>
                <a [href]="url+'#results'" title="results">Results</a>
              </li>
              }
              <li>
                <a [href]="url+'#pricing'" title="pricing">Pricing</a>
              </li>
            </ul>
            <!-- @media screen menu start-->
            <ul class="d-none menu-block collapse-menu">
              <li data-target="#navbarNav" data-toggle="collapse">
                <a [href]="url+'#features'" title="features">Features</a>
              </li>
              <li data-bs-target="#navbarNav" data-bs-toggle="collapse">
                <a [href]="url+'#methods'" title="methods">Methods</a>
              </li>
              @if(url==='/email-validation'){
              <li data-bs-target="#navbarNav" data-bs-toggle="collapse">
                <a [href]="url+'#results'" title="results">Results</a>
              </li>
              }
              <li data-bs-target="#navbarNav" data-bs-toggle="collapse">
                <a [href]="url+'#pricing'" title="pricing">Pricing</a>
              </li>
            </ul>
            <!-- @media screen menu end-->
          </menu>
        </nav>
        }
      </div>
      <div [ngClass]="headerNavMenu ? 'mobile-collapse d-block' :  ''" class="col-xl-4 col-lg-7 col-md-6 col-sm-4 col-4"
        id="navbarNav">
        <button class="btn navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
          aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <section [ngClass]="headerNavMenu ? 'headerNav-public-btn collapse' :  'public-btn'">
          @if (!isUserLoggedIn) {
          <button class="login-btn logo-bounce mb-0" routerLink="/login" title="login">
            <img height="22" width="22" src="theme/images/log-icon.webp" alt="login-icon">
            LOGIN
          </button>
          <button routerLink="/register" title="register" class="get-started-btn logo-bounce">
            <img src="theme/images/power.svg" alt="power"> GET STARTED</button>
          }
          @else if(isUserLoggedIn) {
          <div [ngClass]="{'log-detail': headerNavMenu}">
            <figure class="log-icon2">
              Hi, {{userDetail?.first_name}}
              <div class="dropdown" style="z-index: 99999999;">
                <div class="dropdown-toggle" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                </div>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <li>
                    <a routerLink="/dashboard" title="dashboard"><img src="../../theme/images/dashboard-black.svg"
                        class="dropdown-menu-icon" alt="dashboard"> Dashboard</a>
                  </li>
                  <li>
                    <a href="javascript:;" title="logout" (click)="logout()"><img
                        src="../../theme/images/power-off-black.svg" class="dropdown-menu-icon" alt="power"> Logout</a>
                  </li>
                  <img src="../../theme/images/users.svg" class="drop-down-bg-image" alt="users">
                </ul>
              </div>
            </figure>
          </div>
          }
          <!-- @if (!isUserLoggedIn) {
          
          } -->
        </section>
      </div>
    </div>
  </div>
  }
</div>
<!-- HEADER END -->